export const ConsumerPhoneValidationSectionErrorUat = {
  invalidCode:
    'workflow.consumerPhoneValidation.validatePhoneNumber.invalidCodeError',
  verificationAttemptsExhausted:
    'workflow.consumerPhoneValidation.validatePhoneNumber.verificationAttemptsExhausted'
}
